import React, { useState, useEffect } from 'react'
import {
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material'
import MenuList from '../MenuList'
const companies = [
  {
    id: 1,
    name: 'Microsoft',
    logo: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31'
  },
  {
    id: 2,
    name: 'Zapier',
    logo: '/img/zapier.svg'
  },
  {
    id: 3,
    name: 'Hyland',
    logo: '/img/hyland.svg'
  },
  {
    id: 4,
    name: 'Google',
    logo: '/img/google.png'
  },
  {
    id: 5,
    name: 'Sales Force',
    logo: 'https://a.sfdcstatic.com/shared/images/c360-nav/salesforce-with-type-logo.svg'
  }
]

const CompanyForm = () => {
  const [selectedCompany, setSelectedCompany] = useState(companies[0]) // Default selection
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [selectedApp, setSelectedApp] = useState('On Base') // Default radio button
  const [formData, setFormData] = useState({
    connections: '',
    endpointUrl: '',
    apiToken: '',
    username: '',
    password: '',
    comments: ''
  })

  useEffect(() => {
    // Reset form when a new company is selected
    setFormData({
      connections: '',
      endpointUrl: '',
      apiToken: '',
      username: '',
      password: '',
      comments: ''
    })
  }, [selectedCompany])

  const handleSelectCompany = company => {
    setSelectedCompany(company)
  }

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleReset = () => {
    setFormData({
      connections: '',
      endpointUrl: '',
      apiToken: '',
      username: '',
      password: '',
      comments: ''
    })
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <div className='flex items-center space-x-4'>
        <MenuList isOpen={isMenuOpen} toggleMenu={toggleMenu} />

        <h1 className='py-2 text-2xl text-orange-600'>Integrations</h1>
      </div>

      <div className='flex pace-x-6'>
        {/* Vertical List */}
        <div className='flex flex-col w-1/4 border rounded-lg p-4 space-y-4 bg-gray-50'>
          {companies.map(company => (
            <div
              key={company.id}
              onClick={() => handleSelectCompany(company)}
              className={`flex items-center p-3 rounded-lg cursor-pointer ${
                selectedCompany?.id === company.id
                  ? 'bg-orange-100'
                  : 'bg-white'
              } hover:bg-orange-200`}
            >
              <img
                src={company.logo}
                alt={company.name}
                width='104'
                height='28'
              />
            </div>
          ))}
        </div>

        {/* Form */}
        {selectedCompany && (
          <div className='flex flex-col w-3/4 p-6 border rounded-lg bg-white shadow-md items-center'>
            <h3 className='font-semibold py-2 text-2xl text-orange-600 mb-10'>
              Integrations for {selectedCompany.name}
            </h3>
            <RadioGroup
              row
              value={selectedApp}
              onChange={e => setSelectedApp(e.target.value)}
              className='mb-4'
            >
              <FormControlLabel
                value='On Base'
                control={<Radio />}
                label='On Base'
              />
              <FormControlLabel
                value='Application 2'
                control={<Radio />}
                label='Application 2'
              />
              <FormControlLabel
                value='Application 3'
                control={<Radio />}
                label='Application 3'
              />
            </RadioGroup>
            <FormControl
              fullWidth
              className='w-1/2 items-center mb-4'
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '10px',
                width: '435px'
              }}
            >
              <InputLabel>Connections</InputLabel>
              <Select
                name='connections'
                value={formData.connections}
                onChange={handleChange}
                style={{ width: 'calc(100% - 120px)' }}
              >
                <MenuItem value=''>Connections</MenuItem>
                <MenuItem value='Connection 1'>Connection 1</MenuItem>
                <MenuItem value='Connection 2'>Connection 2</MenuItem>
              </Select>
              <Button
                variant='contained'
                style={{
                  backgroundColor: 'rgb(234, 88, 12)',
                  color: 'white',
                  height: '40px'
                }}
              >
                + Add
              </Button>
            </FormControl>
            <br />
            <TextField
              label='Endpoint URL'
              name='endpointUrl'
              value={formData.endpointUrl}
              onChange={handleChange}
              className='mb-4 w-1/2'
            />
            <br />
            <TextField
              label='API Token'
              name='apiToken'
              value={formData.apiToken}
              onChange={handleChange}
              className='mb-4 w-1/2'
            />
            <br />
            <TextField
              label='Username'
              name='username'
              value={formData.username}
              onChange={handleChange}
              className='mb-4 w-1/2'
            />
            <br />
            <TextField
              label='Password'
              name='password'
              type='password'
              value={formData.password}
              onChange={handleChange}
              className='mb-4 w-1/2'
            />
            <br />
            <TextField
              label='Comments'
              name='comments'
              value={formData.comments}
              onChange={handleChange}
              multiline
              rows={4}
              className='mb-4 w-1/2'
            />
            <br />
            <div className='flex justify-end space-x-4'>
              <Button
                variant='contained'
                style={{ backgroundColor: 'rgb(234, 88, 12)', color: 'white' }}
              >
                Update
              </Button>
              <Button
                variant='outlined'
                onClick={handleReset}
                style={{ color: 'gray', borderColor: 'gray' }}
              >
                Reset
              </Button>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default CompanyForm
